import { render, staticRenderFns } from "./people-profile-related-list-app.vue?vue&type=template&id=2bf515ea&"
import script from "./people-profile-related-list-app.vue?vue&type=script&lang=js&"
export * from "./people-profile-related-list-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports